import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "txtLeft" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_5 = { class: "font-weight-bold" }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "d-inline-block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col text-end" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xl" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Facility", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Service Line", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Department", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Status", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Shift Code", -1)
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Skill", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Date", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Start Time", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "End Time", -1)
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Charge", -1)
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Float", -1)
const _hoisted_62 = { class: "" }
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Cancelled", -1)
const _hoisted_66 = { class: "" }
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Cancellation Reason", -1)
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Unscheduled Absence", -1)
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Note", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("legend", {
      class: _normalizeClass([!_ctx.assignmentReviewInput.showTitle ? 'd-none' : ''])
    }, [
      _createTextVNode(_toDisplayString(_ctx.assignmentReviewInput.title) + "  ", 1),
      _createElementVNode("span", {
        class: _normalizeClass([!_ctx.assignmentReviewInput.showStatus ? 'd-none' : '', 'text-danger font-weight-bold'])
      }, _toDisplayString(_ctx.assignmentReviewInput.status), 3)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'calendar'],
            size: "sm",
            class: "mr-1"
          }),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.DisplayDate), 1),
          _createTextVNode("  "),
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'clock'],
            size: "sm",
            class: "mr-1"
          }),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.DisplayStartTime), 1),
          _createTextVNode(" - "),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.DisplayEndTime), 1),
          _createTextVNode("  "),
          _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.ShiftDuration), 1)
        ])
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.facilityName
              }, null, 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.clusterName
              }, null, 8, _hoisted_20)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.departmentName
              }, null, 8, _hoisted_24)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.productiveDescription
              }, null, 8, _hoisted_29)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("input", {
                class: "form-control",
                name: "shiftCode",
                readonly: "",
                value: _ctx.assignmentReviewInput.shiftCode
              }, null, 8, _hoisted_33)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.skillLevelDescription
              }, null, 8, _hoisted_37)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.DisplayDate
              }, null, 8, _hoisted_42)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("input", {
                    class: "form-control",
                    readonly: "",
                    value: _ctx.DisplayStartTime
                  }, null, 8, _hoisted_48)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("input", {
                    class: "form-control",
                    readonly: "",
                    value: _ctx.DisplayEndTime
                  }, null, 8, _hoisted_52)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.ChargeStatus), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.FloatStatus), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.CancelStatus), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["row", [!_ctx.assignmentReviewInput.showCancelOptions ? 'd-none' : '']])
        }, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.CancelReason
              }, null, 8, _hoisted_70)
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.assignmentReviewInput.unscheduledAbsenceText
              }, null, 8, _hoisted_74)
            ])
          ])
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["col-xl-4", [!_ctx.assignmentReviewInput.showNote ? 'd-none' : '']])
      }, [
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control k-input",
            rows: "4",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Note) = $event)),
            readonly: ""
          }, null, 512), [
            [_vModelText, _ctx.Note]
          ])
        ])
      ], 2)
    ])
  ]))
}